<template>
	<div>
		<div class="sf-search-layout__body__container">
			<sf-search-layout>
				<el-row :gutter="20">
					<el-col :span="13">
						<!-- 부서명 -->
						<search-input
							:label="getMessage_('QWCC001153')"
							paramKey="deptNm"
							@commInput="setSearchParam"
							:propData="searchParams.deptNm"
						></search-input>
					</el-col>
				</el-row>
				<template slot="button">
					<sf-button line icon="search" :onClick="searchList" v-if="isButton_(scrId, 'CR')">
						{{ getButtonMsg_(scrId, 'CR') }}
					</sf-button>
				</template>
			</sf-search-layout>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@qms/comm/commpopup/DeptMngPopup/store/helpers';
import SearchInput from '@qms/Components/SearchInput';
export default {
	props: { scrId: { type: String, default: '' } },
	components: { SearchInput },
	async created() {
		try {
			await this.searchList();
		} catch (error) {
			this.$sf_toast({ type: 'error', message: error?.message });
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		setSearchParam(param) {
			this.setSearchParam_(param);
		},
		async searchList() {
			try {
				this.$sf_toggleLoading(true);
				await this.getDeptMngList_();
			} catch (error) {
				this.$sf_toast({
					type: 'error',
					message: error?.message
				});
			} finally {
				this.$sf_toggleLoading(false);
			}
		}
	},
	computed: { ...rootComputed, ...serviceComputed }
};
</script>

<style lang="scss" scoped>
.sf-button.sf-line-default {
	width: 110px;
	min-width: fit-content;
}
</style>
